<template>
  <Card class="joint-punishment-form">
    <Form ref="dataForm" style="max-width:800px" :model="formItem" :rules="ruleValidate" :label-width="240">
      <Form-item label='区域' prop="Region">
        <city-select-list :city="formItem.Region" @selectCity="selectCity"></city-select-list>
      </Form-item>
      <Form-item label="企业名称" prop="CompanyName">
        <Input v-model="formItem.CompanyName" placeholder="请输入企业名称"></Input>
      </Form-item>
      <Form-item label="统一社会信用代码或工商注册号" prop="BusinessLicense">
        <Input v-model="formItem.BusinessLicense" placeholder="请输入统一社会信用代码或工商注册号"></Input>
      </Form-item>
      <Form-item label="评价等级" prop="Result">
        <Select v-model="formItem.Result" placeholder="请选择评价等级">
          <Option value="A">A级</Option>
          <Option value="B">B级</Option>
          <Option value="C">C级</Option>
        </Select>
      </Form-item>
      <Form-item label="评价年度" prop="Year">
        <Select v-model="formItem.Year" placeholder="请选择评价等级">
          <Option v-for="(y,idx) in years" :key="idx" :value="y">{{ y }}年度</Option>
        </Select>
      </Form-item>
      <FormItem>
        <Button type="primary" size="large" long :loading="submitting" @click="submitFrom">{{ editMode?'提交修改':'提交新增' }}</Button>
      </FormItem>
    </Form>
  </Card>
</template>

<script>
import citySelectList from '../public/CitySelectList'
import leftPad from 'leftpad'
export default {
  name: 'credit-evaluate-result-form',
  components: {
    citySelectList,
  },
  props: {
    data: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    data: function (newVal) {
      if (newVal) {
        Object.assign(this.formItem, newVal)
        this.editMode = true
      } else {
        this.editMode = false
        this.formItem = {
          CompanyName: null,
          BusinessLicense: null,
          Result: null,
          Year: null,
          Region: null,
          Province: null,
          Municipality: null,
          County: null,
          Operator: null
        }
      }
    },
  },
  data () {
    return {
      visible: false,
      editMode: false,
      years: [],
      startYear: 2024,
      formItem: {
        Tid: null,
        CompanyName: null,
        BusinessLicense: null,
        Result: null,
        Year: null,
        Region: null,
        Province: null,
        Municipality: null,
        County: null,
        Operator: null
      },
      ruleValidate: {
        CompanyName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        BusinessLicense: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        Result: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        Year: [
          { required: true, type: 'number', message: '不能为空', trigger: 'blur' },
        ],
        Region: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
      },
      submitEnabled: true,
      submitting: false
    }
  },
  mounted () {
    if (this.$store.getters.name) {
      this.formItem.Operator = this.$store.getters.name
    }
    let curItem = localStorage.getItem('credit-evaluate-result-current')
    if (curItem) {
      curItem = JSON.parse(curItem)
    }
    if (curItem && curItem.Tid && curItem.Tid.toString() === this.$route.params.tid) {
      this.formItem = curItem
      this.editMode = true
      if (curItem.Province > 0) {
        this.getCityCode(curItem.Province, curItem.Municipality, curItem.County)
      }
    }
    for (let y = new Date().getFullYear(); y >= this.startYear; y--) {
      this.years.push(y)
    }
  },
  methods: {
    selectCity (value) {
      this.formItem.Region = value
      if (value.length > 0) {
        this.formItem.Province = parseInt(value.substr(0, 2))
        this.formItem.Municipality = parseInt(value.substr(2, 2))
        this.formItem.County = parseInt(value.substr(4, 2))
      } else {
        this.formItem.Province = 0
        this.formItem.Municipality = 0
        this.formItem.County = 0
      }
    },
    getCityCode (province, municipality, county) {
      this.formItem.Region = leftPad(province, 2) +
        leftPad(municipality, 2) +
        leftPad(county, 2)
    },
    submitFrom () {
      if (this.editMode) {
        return this.edit()
      } else {
        return this.create()
      }
    },
    create () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.submitting = true
          this.submitEnabled = false
          this.$Spin.show()
          let model = {}
          Object.assign(model, this.formItem)
          this.$Api.Project.addCreditEvaluateResult(model).then(() => {
            this.$Message.success('操作成功！!')
            this.$Spin.hide()
            this.submitEnabled = true
            this.submitting = false
            this.formItem = {
              CompanyName: null,
              BusinessLicense: null,
              Result: null,
              Year: null,
              Region: null,
              Province: null,
              Municipality: null,
              County: null,
              Operator: null
            }
          }).catch(err => {
            this.$Spin.hide()
            this.$Message.error('提交失败！!' + err.message)
            this.submitEnabled = true
            this.submitting = false
          })
        } else {
          this.$Message.error('表单验证失败!')
          this.submitEnabled = true
          this.submitting = false
        }
      })
    },
    edit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.submitting = true
          this.submitEnabled = false
          this.$Spin.show()
          let model = {}
          Object.assign(model, this.formItem)
          model.Amount *= 100
          this.$Api.Project.editCreditEvaluateResult(model).then(() => {
            this.$Message.success('操作成功！!')
            this.$Spin.hide()
            this.submitEnabled = true
            this.submitting = false
          }).catch(err => {
            this.$Spin.hide()
            this.$Message.error('提交失败！!' + err.message)
            this.submitEnabled = true
            this.submitting = false
          })
        } else {
          this.$Message.error('表单验证失败!')
          this.submitEnabled = true
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
